import React, {useEffect, useState} from "react";
import {Box, Grid, MenuItem, Typography} from "@material-ui/core";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import {MUIAutoComplete, MUIInput, MUISelect} from "../../utils/formUtils";
import addressData from "../../data/addressData.json";
import Button from "@material-ui/core/Button";
import axiosInstance from "../../api";
import Spinner from "../../components/Spinner";
import {Alert} from "@material-ui/lab";
import GoogleMaps from "../../utils/GooglePlacesInput";import {AVAILABLE_ACTIONS} from "../../utils/constants";
import {getAddressObject, handleCountryConversion, handleCountyConversion} from "../../utils/fmapUtils";

const validationSchema = yup.object().shape({

});
export default function AgentContactInfoEditTileGP({agentInformation, setShowEdit, agentId, onSuccessfulUpdate}) {
    const {handleSubmit, control, trigger, formState: {errors}} = useForm({resolver: yupResolver(validationSchema)});
    const [pageInfo, setPageInfo] = useState(agentInformation);
    const [address, setAddress] = useState(Object.assign({},agentInformation.mailingAddress));
    const [countyList, setCountyList] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [countryList, setCountryList] = useState([]);
    const [showSpinner, setShowSpinner] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [isAddressStandardized, setIsAddressStandardized] = useState(false);

    useEffect(() => {
        // Anything in here is fired on component mount.
        // fetching static data
        setCountyList(['Out of Florida', ...addressData.county]);
        setStateList([{"label": 'Out of Florida', "value":"OF"}, ...addressData.state]);
        setCountryList(addressData.usCountry);
    }, []);

    const handleFormChange = (event) => {
        console.log('page info edit emali', event, pageInfo);
        if (['addressLine1','addressLine2','city','county','state','zip','country'].includes(event.target.name)) {
            setAddress(Object.assign({},address,{[event.target.name]: event.target.value}));
        } else {
            setPageInfo(Object.assign({}, pageInfo, {[event.target.name]: event.target.value}));
        }
    };

    const validationRules = (data) => {
        let fields = [];
        if (data && !data.agencyName) {
            fields.push('Agency Name')
        }

        if (data && !data.email) {
            fields.push('Email Address')
        } else if (!validateEmail(data.email)) {
            fields.push('Valid Email Address');
        } else if (data.email.length > 50) {
            fields.push('Email Address with 50 characters or less');
        }

        if (data && !data.workPhone) {
            fields.push('Phone')
        }

        if (!address.addressLine1) {
            fields.push('Address')
        }

        if (!address.zip) {
            fields.push('Zip')
        }

        if (!address.city) {
            fields.push('City')
        }

        if (!address.county) {
            fields.push('County')
        }

        if (!address.state) {
            fields.push('State')
        }

        debugger
        if (fields.length >0) {
            setErrorMessage('Fields : '+fields+' are required.');
            return true;
        }
        return false;
    }

    const validateEmail = (email) => {
        const re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    const onSubmit = data => {
        if (validationRules(data)) return;
        let payload = {
            agentId:agentId.agentId,
            agencyName: data.agencyName,
            agentContact: {
                contactId: agentInformation?.agentContact?.contactId,
                personId: agentInformation?.agentContact?.personId,
                cellPhoneNumber: data.mobile,
                phoneNumber: data.workPhone,
                email: data.email,
            }, agentMailingAddress: {
                addressId: agentInformation?.mailingAddress?.addressId,
                addressLine1: address.addressLine1,
                addressLine2: address.addressLine2,
                city: address.city,
                state: address.state,
                county: address.county,
                country: address.country,
                zip: address.zip
            }
        };
        setErrorMessage(null);
        if ((data.state === 'FL' && data.county === 'Out of Florida') || (data.state !== 'FL' && data.county !== 'Out of Florida')) {
            setErrorMessage('State/ County combination invalid. Please select a valid County.');
            return
        }

        setShowSpinner(true);
        axiosInstance.post('agents/update-agent', payload)
            .then((data) => onSuccessfulUpdate())
            .catch(error => setErrorMessage('An error occured. Please try again later.'))
            .finally(() => setShowSpinner(false));
    }


    const populateValues = (data) => {
        //console.log(data[0].address_components)
        //reset();
        if( data && data[0] && data[0].address_components){
            debugger
            const addressValue =  getAddressObject(data[0].address_components)
            let countyValue = (addressValue.region && addressValue.region === 'Florida') ? handleCountyConversion( addressValue.county, countyList) : 'Out of Florida';
            let stateValue = stateList?.filter(x => x.label === addressValue.region)[0]?.value;
            stateValue = (stateValue) ? stateValue : 'OF';
            debugger
            setAddress(Object.assign({}, address, {
                addressLine1: addressValue.home + ' ' + addressValue.street,
                city: addressValue.city,
                state: stateValue,
                county: countyValue,
                zip: addressValue.postal_code,
                country:  handleCountryConversion(addressValue.country)
            }));
            setIsAddressStandardized(true);
        }
    }




    const resetValues = () => {
        debugger
        setAddress(Object.assign({},agentInformation.mailingAddress));
    }

    if (showSpinner) return <Spinner/>

    return (
        <>
            <Box m={2} marginBottom={0}>
                <Typography variant="h5" component="h2">
                    Edit Contact
                </Typography>
            </Box>
            <form
                onSubmit={handleSubmit(onSubmit)}>
                <Box m={3} marginTop={0}>
                    <Grid container alignItems="flex-start" spacing={2} style={{paddingLeft: 8, paddingTop: 8}}>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUIInput control={control} name="agencyName"
                                      defaultValue={pageInfo?.agencyName}
                                      inputPrp={{maxLength: 100}}
                                      value={pageInfo?.agencyName} label="Agency Name"
                                      onInputChange={handleFormChange} errors={errors}/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUIInput control={control} name="email" inputPrp={{maxLength: 50}}
                                      defaultValue={pageInfo?.email}
                                      value={pageInfo?.email} label="Email Address"
                                      onInputChange={handleFormChange} errors={errors}/>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <MUIInput control={control} name="workPhone" inputPrp={{maxLength: 15}}
                                      defaultValue={pageInfo?.workPhone}
                                      value={pageInfo?.workPhone} label="Primary Phone"
                                      onInputChange={handleFormChange} errors={errors}/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUIInput control={control} name="mobile" inputPrp={{maxLength: 15}}
                                      defaultValue={pageInfo?.mobile}
                                      value={pageInfo?.mobile} label="Alternate Phone"
                                      onInputChange={handleFormChange} errors={errors}/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>

                            <GoogleMaps control={control} name="addressLine12" inputPrp={{maxLength: 200}} onValuChange={(newValue) =>
                            {
                                address.addressLine1 = newValue
                            }} valueOnLoad={address?.addressLine1}
                                        label="Address Line 1" errors={errors}
                                        callback={populateValues} resetCallback={resetValues}/>
                            {/*<MUIInput control={control} name="addressLine1" inputPrp={{maxLength: 200}}*/}
                            {/*          defaultValue={address?.addressLine1}*/}
                            {/*          value={address?.addressLine1} label="Address Line 1"*/}
                            {/*          onInputChange={handleFormChange} errors={errors}/>*/}

                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUIInput control={control} name="addressLine2" inputPrp={{maxLength: 200}}
                                      defaultValue={address?.addressLine2}
                                      value={address?.addressLine2} label="Address Line 2"
                                      onInputChange={handleFormChange} errors={errors}></MUIInput>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUIInput control={control} name="city" inputPrp={{maxLength: 200}}
                                      defaultValue={address?.city}
                                      value={address?.city} label="City"
                                      onInputChange={handleFormChange} errors={errors}></MUIInput>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUIAutoComplete id="county" control={control} name="county" label="County"
                                             errors={errors}
                                             value={address?.county}
                                             onValueChange={handleFormChange} options={countyList}/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUIInput control={control} name="zip"
                                      defaultValue={address?.zip}
                                      inputPrp={{maxLength: 5}}
                                      value={address?.zip} label="Zip"
                                      error={address?.errors?.zip}
                                      onInputChange={handleFormChange} errors={errors}></MUIInput>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUISelect control={control} errors={errors} id="state" name="state"
                                       label="State"
                                       value={address?.state}
                                       defaultValue={address?.state}
                                       onFormChange={handleFormChange}>
                                {stateList.map(item => <MenuItem key={item.label}
                                                                 value={item.value}>{item.label}</MenuItem>
                                )}
                            </MUISelect>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUISelect control={control} errors={errors} id="country" name="country"
                                       label="Country"
                                       value={address?.country}
                                       defaultValue={address?.country}
                                       onFormChange={handleFormChange}>
                                {countryList.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>
                                )}
                            </MUISelect>
                        </Grid>
                    </Grid>
                    <br/>
                    <Box component="span" justifyContent="flex-start" alignItems="flex-start" display="flex">
                        <Button type="submit" size="small" color="primary" variant="contained">Save</Button> &nbsp;
                        <Button size="small" color="primary" variant="contained"
                                onClick={() => {resetValues();setShowEdit(false);}}>Cancel</Button> &nbsp;
                    </Box>
                    <br/>
                    {errorMessage &&
                    <Box component="span" justifyContent="flex-start" alignItems="flex-start" display="flex">
                        <div>
                            <br/>
                            <Alert variant="filled" severity="error">{errorMessage}</Alert>
                        </div>
                    </Box>}
                </Box>
            </form>
        </>
    );
}
